module.exports = __webpack_public_path__ + "img/horizontal_3_4_7042.c7292c0e.png";